// client/src/pages/ResourceEditPage.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import ResourceEdit from '../components/ResourceEdit';
import '../styles/ResourceEditPage.css';
import { T } from '../lib/gt-shim';


const ResourceEditPage = () => {
  const { id } = useParams();

  return (<T id="pages.resourceeditpage.0">
    <div className="resource-edit-page">
      <Link to="/admin/resources" className="back-link">
        <FaArrowLeft /> Back to Resources
      </Link>
      
      <ResourceEdit resourceId={id} />
    </div></T>
  );
};

export const ResourceCreatePage = () => {
  return (
    <T id="pages.resourcecreatepage.0">
      <div className="resource-edit-page">
        <Link to="/admin/resources" className="back-link">
          <FaArrowLeft /> Back to Resources
        </Link>
        <ResourceEdit />
      </div>
    </T>
  );
};

export default ResourceEditPage;